import { Col, Divider, Form, Select } from 'antd'
import { DarkGrayBackground } from 'atom/discount'
import CoreBadge from 'components/badge/Badge'
import { useDiscountSchemaTranslation } from 'hooks/translation/useDiscountSchemaTranslation'
import { PricingSchemaPayload } from 'models/price'
import { usePricingSchemasTranslation } from '../../../../hooks/translation/usePricingSchemaTranslation'

interface props {
  index: number
  pricingSchemaValues: PricingSchemaPayload | undefined
}

export const DiscountConstantsSectionModal: React.FC<props> = ({ index, pricingSchemaValues }) => {
  const { constantsText } = usePricingSchemasTranslation()
  const { flatFeeInfoText, basePlanText, noFlatFeeText, flatFeeText } = useDiscountSchemaTranslation()

  return (
    <>
      <Divider>
        <span className="paragraph-02-bold">{constantsText}</span>
      </Divider>
      <DarkGrayBackground>
        <Col span={10}>
          <Form.Item label={<>{basePlanText}:</>}>
            {pricingSchemaValues?.flat_fee === 0 ? (
              <div className="paragraph-01-regular">{noFlatFeeText}</div>
            ) : (
              <CoreBadge title={`$${pricingSchemaValues?.flat_fee?.toFixed(2)}`} />
            )}
          </Form.Item>
        </Col>
      </DarkGrayBackground>
      <Form.Item
        label={<>{flatFeeText}:</>}
        name={[index, 'flat_fee']}
        style={{ alignItems: 'flex-start', marginBottom: '0px' }}
        className="flat-fee"
        help={flatFeeInfoText}
      >
        <Select disabled={pricingSchemaValues?.flat_fee === 0}>
          <Select.Option value={pricingSchemaValues?.flat_fee}>
            {pricingSchemaValues?.flat_fee?.toFixed(2)}
          </Select.Option>
          {pricingSchemaValues?.flat_fee !== 0 && <Select.Option value={0}>0.00</Select.Option>}
        </Select>
      </Form.Item>
    </>
  )
}
